var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-view"},[_c('div',{staticClass:"chart-wrapper"},[_c('div',{ref:"ChinaChart",staticClass:"china-chart"}),_c('div',{staticClass:"map-view-holder"})])])}
var staticRenderFns = []

export { render, staticRenderFns }